export const updateText = async (functionParameters = {}) => {

    const recursiveUpdate = (await import(/* webpackPrefetch: true */ `../general/recursiveUpdate`) ).recursiveUpdate;

    functionParameters["submissionFuncPath"] = "apps/texts/updateText";
    functionParameters["sideMenuToUse"] = "texts";
    functionParameters["urlDestination"] = functionParameters["urlDestination"] || "update";
    return recursiveUpdate(functionParameters);

};
